export const PaymentErrorsMapper: {[key: string]: string} = {
  INELIGIBLE_CARD_VENDOR: 'Inneligible vendor',
  INVALID_NAME: 'Invalid name',
  INVALID_NUMBER: 'Invalid credit card number',
  INVALID_EXPIRY: 'Invalid expiry date',
  INVALID_CVV: 'Invalid CVV number'
}
